import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import "../../css/ListUsers.css";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
import SurveyProductReadOnlyRow from "../../components/SurveyProductReadOnlyRow";
import SurveyProductTableRow from "../../components/SurveyProductTableRow";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import CompanyProductFilter from "./CompanyProductFilter";
import { useTranslation } from 'react-i18next';


function ListSurveyProducts() {
	const navigate = useNavigate();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [errorValue, setErrorValue] = useState("");
	const [keyword, setKeyword] = useState("");
	const [companyId, setCompanyId] = useState(0);
	const [productList, setProductList] = useState([]);
	const [surveyList, setSurveyList] = useState([]);
	const [surveyProductList, setSurveyProductList] = useState([]);
	const [count, setCount] = useState(0);
	const { t } = useTranslation();
	const userCtx = useContext(UserContext);

	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		fetchSurveyList();
	}, []);

	const initialValues = {
		companyId: 0,
		companyProductKey: 0,
		commodityKey: 0,
		surveyKey: 0,
		productName: "",
		productSku: "",
		description: "",
		updatedById: userCtx.loggedInUserId,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	const onClickFilterCallback = (searchFilter, selectedCompanyId) => {
		setKeyword(searchFilter);
		setCompanyId(selectedCompanyId);
		setFormValues({ ...formValues, ["companyId"]: selectedCompanyId });
		fetchSurveyProducts(searchFilter, selectedCompanyId);
	}
	function fetchCompanyProducts(selectedCompanyId) {
		setErrorValue("");
		setIsLoading(true);
		setSurveyProductList([]);
		resetRowTable();
		if (selectedCompanyId == 0) {
			setErrorValue(t("error.companyReqd"));
		}
		setCompanyId(selectedCompanyId);
		setFormValues({ ...formValues, ["companyId"]: selectedCompanyId });
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: true, companyId: selectedCompanyId }),
		};
		try {
			FetchUtil.fetchAPI("MGetCompanyProduct", "/Service/CompanyService/GetCompanyProduct", requestOptions, getCompanyProductsSuccess, getCompanyProductsFail);
		} catch (error) {
			setIsLoading(false);
			setErrorValue(error.message);
		}
	}

	function getCompanyProductsFail(redirect) {
		setIsLoading(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.getProdFailed"));
	}
	function getCompanyProductsSuccess(responseData) {
		let getCompanyProductResponse;
		if (responseData) {
			getCompanyProductResponse = responseData.getCompanyProductResponse;
			if (getCompanyProductResponse && getCompanyProductResponse.errorCode === "0") {
				setProductList([...getCompanyProductResponse.products]);
			} else if (getCompanyProductResponse && getCompanyProductResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getCompanyProductResponse) {
				setErrorValue(t("error.error") + " " + getCompanyProductResponse.errorMessage);
			}
		}
		setIsLoading(false);
	}
	function fetchSurveyList() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: false }),
		};
		try {
			FetchUtil.fetchAPI("MGetSurveyList", "/Service/StaticHelper/GetSurveyList", requestOptions, getSurveyListSuccess, getSurveyListFail);
		} catch (error) {
			setErrorValue(error.message);
		}
	}

	function getSurveyListFail(redirect) {
		setErrorValue(t("error.getSurveyListFailed"));
	}
	function getSurveyListSuccess(responseData) {
		let getSurveyListResponse;
		if (responseData) {
			getSurveyListResponse = responseData.getSurveyListResponse;
			if (getSurveyListResponse && getSurveyListResponse.errorCode === "0") {
				setSurveyList([...getSurveyListResponse.surveyList]);
			} else if (getSurveyListResponse) {
				setErrorValue(t("error.error") + " " + getSurveyListResponse.errorMessage);
			}
		}
	}

	function fetchSurveyProducts(searchFilter, selectedCompanyId) {
		setErrorValue("");
		setIsLoading(true);
		resetCounter();
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: true, searchValue: searchFilter, companyId: selectedCompanyId }),
		};
		try {
			FetchUtil.fetchAPI("MGetSurveyProduct", "/Service/CompanyService/GetSurveyProduct", requestOptions, getSurveyProductsSuccess, getSurveyProductsFail);
		} catch (error) {
			setIsLoading(false);
			setErrorValue(error.message);
		}
	}

	function getSurveyProductsFail(redirect) {
		setIsLoading(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.getProdFailed"));
	}
	function getSurveyProductsSuccess(responseData) {
		let getSurveyProductResponse;
		if (responseData) {
			getSurveyProductResponse = responseData.getSurveyProductResponse;
			if (getSurveyProductResponse && getSurveyProductResponse.errorCode === "0") {
				setSurveyProductList([...getSurveyProductResponse.products]);
			} else if (getSurveyProductResponse && getSurveyProductResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getSurveyProductResponse) {
				setErrorValue(t("error.error") + " " + getSurveyProductResponse.errorMessage);
			}
		}
		setIsLoading(false);
	}
	const handleDeleteClick = (event, surveyProdListItem, completeCallback) => {
		event.preventDefault();
		deleteProduct(surveyProdListItem, completeCallback);
	};
	const deleteProduct = (surveyProdListItem, completeCallback) => {
		let action = 3;
		if (surveyProdListItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			companyId: companyId,
			surveyProductKey: surveyProdListItem.surveyProductKey,
			companyProductKey: surveyProdListItem.companyProductKey,
			surveyKey: surveyProdListItem.surveyKey,
			statusCode: surveyProdListItem.statusCode,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteCompanyProduct", "/Service/CompanyService/DeleteSurveyProduct", requestOptions, deleteProductSuccess, deleteProductFail, completeCallback);
		} catch (error) {
			setErrorValue(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteProductFail(redirect, completeCallback) {
		setErrorValue(t("error.prodEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteProductSuccess(responseData, completeCallback) {
		let deleteSurveyProductResponse;
		if (responseData) {
			deleteSurveyProductResponse = responseData.deleteSurveyProductResponse;
			if (deleteSurveyProductResponse) {
				if (deleteSurveyProductResponse.errorCode === "0") {
					resetRowTable();
					fetchSurveyProducts(keyword, companyId);
				} else if (deleteSurveyProductResponse && deleteSurveyProductResponse.errorCode === "114") {
					navigate("/", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else {
					setErrorValue(t("error.error") + " " +
						deleteSurveyProductResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setErrorValue("");
		if (!add) {
			setAdd(true);
		} else {
			setErrorValue(t("error.only1RowAllowed"));
		}
	};
	const removeRowTable = () => {
		setErrorValue("");
		resetRowTable();
		setIsLoading(false);
	};

	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setErrorValue("");
		let found = false;
		if (!formValues.companyId) {
			setErrorValue(t("error.companyReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (surveyProductList.length > 0) {
				surveyProductList.map((surveyProdListItem, index) => {
					if (surveyProdListItem.companyProductKey === setValues.companyProductKey
						&& surveyProdListItem.surveyKey === setValues.surveyKey) {
						setErrorValue(t("error.prodDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveProduct(action, setValues, completeCallback);
			}
		}
	};
	const saveProduct = (action, setValues, completeCallback) => {
		let serverParams = {
			companyId: formValues.companyId,
			companyProductKey: setValues.companyProductKey,
			surveyKey: setValues.surveyKey,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateSurveyProduct", "/Service/CompanyService/AddUpdateSurveyProduct", requestOptions, saveProductSuccess, saveProductFail, completeCallback);
		} catch (error) {
			setErrorValue(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveProductFail(redirect, completeCallback) {
		setErrorValue(t("error.prodEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveProductSuccess(responseData, completeCallback) {
		let addUpdateSurveyProductResponse;
		if (responseData) {
			addUpdateSurveyProductResponse = responseData.addUpdateSurveyProductResponse;
			if (addUpdateSurveyProductResponse) {
				if (addUpdateSurveyProductResponse.errorCode === "0") {
					resetRowTable();
					fetchSurveyProducts(keyword, companyId);
				} else if (addUpdateSurveyProductResponse.errorCode === "114") {
					navigate("/", {
						state: {
							errorMessage: t("error.sessionTimeout"),
						},
					});
				} else {
					setErrorValue(t("error.error") + " " +
						addUpdateSurveyProductResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	return (
		<div className="container-fluid">
			<Header />
			<div className={"container-fluid container_list viewh-85"}>
				{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
					<>
						<div className="row">
							<div className="col">
								<div
									id="inerrorMessage"
									className={
										(errorValue) ? "errorblock" : "errorblock hide"
									}
								>
									{errorValue ? errorValue : ""}
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<div id="placeholder_1" className="placeholder-pg"></div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<CompanyProductFilter t={t} setErrorValue={setErrorValue} onClickFilterCallback={onClickFilterCallback}
									defaultKeyword={keyword} defaultCompanyId={companyId} fetchCompanyProducts={fetchCompanyProducts}
									setSurveyProductList={setSurveyProductList} setAdd={setAdd} />
							</div>
							{(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
						</div>
						<div className="row">
							<div className="col">
								<div id="placeholder_2" className="placeholder-pg"></div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<table className="list-table" role="table">
									<thead>
										<tr role="row">
											<th className="list-th">{t("page.survey.name")}</th>
											<th className="list-th">{t("page.prod") + '-' + t("page.prodNum")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "9vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</thead>
									<tbody role="rowgroup">
										{add && addRowTop &&
											<SurveyProductTableRow
												index={count}
												productList={productList}
												surveyList={surveyList}
												handleSubmit={handleSubmit}
												setError={setErrorValue}
												t={t}
												setAdd={setAdd}
												oddIdx={((surveyProductList.length % 2) > 0) ? true : false} />
										}
										{surveyProductList.length > 0 && (
											surveyProductList.map((surveyProdListItem, index) => (
												<SurveyProductReadOnlyRow
													index={count}
													t={t}
													surveyProdListItem={surveyProdListItem}
													handleDeleteClick={handleDeleteClick}
													oddIdx={((index % 2) > 0) ? true : false}
													setError={setErrorValue}
												/>
											))
										)}
										{add && addRowBottom &&
											<SurveyProductTableRow
												index={count}
												productList={productList}
												surveyList={surveyList}
												handleSubmit={handleSubmit}
												setError={setErrorValue}
												t={t}
												setAdd={setAdd}
												oddIdx={((surveyProductList.length % 2) > 0) ? true : false} />
										}
									</tbody>
									{(surveyProductList.length > 10) ? (<tfoot>
										<tr role="row">
											<th className="list-th">{t("page.survey.name")}</th>
											<th className="list-th">{t("page.prod") + '-' + t("page.prodNum")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "9vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</tfoot>
									) : (<></>)}
								</table>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div
									id="berrorMessage"
									className={
										(errorValue) ? "errorblock" : "errorblock hide"
									}
								>
									{errorValue ? errorValue : ""}
								</div>
							</div>
						</div>
					</>
					: null}
			</div>
			<div className="footer_container">
				<Footer />
			</div>
		</div>
	);
}

export default ListSurveyProducts;